import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useParams } from "react-router-dom";
import Checkout from "../Checkout/Checkout";
// Customize the appearance of Elements using the Appearance API.
const appearance = {
  theme: "stripe",
  variables: {
    colorPrimary: "#ed5f74",
    borderRadius: "20px",
    fontFamily:
      "--body-font-family: -apple-system, BlinkMacSystemFont, sans-serif",
    colorBackground: "#fafafa",
  },
};
const CheckoutForm = () => {
  const { id } = useParams();
  return (
    <div className=" bg-[#fff] flex justify-center items-center py-[40px] pb-[100px]">
      <div className="w-[100%] max-w-[1440px] p-[25px] rounded">
        <Elements
          stripe={loadStripe(process.env.REACT_APP_STRIPE_KEY)}
          options={{ clientSecret: id, appearance: appearance }}
        >
          <Checkout clientSecret={id} />
        </Elements>
      </div>
    </div>
  );
};

export default CheckoutForm;
